import { createMsgWithdrawDelegatorReward, generateTypes } from '@evmos/eip712';
import {
  createMsgWithdrawDelegatorReward as protoMsgWithdrawDelegatorReward,
} from '@evmos/proto/dist/messages/distribution/distribution';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';

interface MsgWithdrawDelegatorRewardParams {
  validatorAddress: string;
}

const MSG_WITHDRAW_DELEGATOR_REWARD_TYPES = {
  MsgValue: [
    { name: 'delegator_address', type: 'string' },
    { name: 'validator_address', type: 'string' },
  ],
};

export const createTxMsgWithdrawDelegatorReward = (
  context: TxContext,
  params: MsgWithdrawDelegatorRewardParams | MsgWithdrawDelegatorRewardParams[],
): TxPayload => {
  const typedData = createEIP712MsgWithdrawDelegatorReward(context, params);
  const cosmosMsg = createCosmosMsgWithdrawDelegatorReward(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgWithdrawDelegatorReward = (
  context: TxContext,
  params: MsgWithdrawDelegatorRewardParams | MsgWithdrawDelegatorRewardParams[],
): EIP712TypedData => {
  const types = generateTypes(MSG_WITHDRAW_DELEGATOR_REWARD_TYPES);
  const messageList = Array.isArray(params) ? params : [ params ];
  const messages = messageList.map(({ validatorAddress }) =>
    createMsgWithdrawDelegatorReward(context.sender.accountAddress, validatorAddress));
  return { types, message: messages.length === 1 ? messages[0] : messages };
};

const createCosmosMsgWithdrawDelegatorReward = (
  context: TxContext,
  params: MsgWithdrawDelegatorRewardParams | MsgWithdrawDelegatorRewardParams[],
) => {
  const messageList = Array.isArray(params) ? params : [ params ];
  return messageList.map(({ validatorAddress }) =>
    protoMsgWithdrawDelegatorReward(context.sender.accountAddress, validatorAddress));
};

